'use client'
import { useMemo, type FC } from 'react'
import styled from 'styled-components'
import { ContentHeader } from './contents/ContentHeader'
import { ContentTwoCols } from './contents/ContentTwoCols'
import { ContentSlider } from './contents/ContentSlider'
import { ContentGrid } from './contents/ContentGrid'
import type { TypeCmsContent } from '@/schema'


type Props = {
  data?: TypeCmsContent[]
}

const ContentByType = {
  header: ContentHeader,
  two_columns: ContentTwoCols,
  slider: ContentSlider,
  list: ContentGrid,
}

const getContentByType = (data: TypeCmsContent[] = []) => {
  return data.map((item, idx) => {
    const Component = ContentByType[item.type]
    // @ts-expect-error - Any needed
    return Component ? <Component key={idx + item.id} data={item?.data} /> : null
  })
}

export const MainContents:FC<Props> = ({ data }) => {
  const Items = useMemo(() => getContentByType(data), [data])

  return (
    <Main>
      {Items}
    </Main>
  )
}

const Main = styled.main`
  section {
    &:first-child {
      padding-top: 10px;
    }
  }
`
